export enum SAVE_DATA_STATUS {
	OK = 'OK',
	KO = 'KO',
}

export enum FIELD_VALIDATION_ERROR {
	VALIDATION = 'VALIDATION',
	BLOCKED = 'BLOCKED',
}

export const SNACKBAR_DELAY = 3000

export const RETURNS_HELP_LINK = '/help/returns'

export const GENERIC_INPUT_VALIDATION =
	"^[\\p{L}\\p{N}][ \\p{L}\\p{N}'-]*[\\p{L}\\p{N}]$"
